import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const DISCOUNTS_BASE_QUERY_KEY = 'discounts';

export const discountsApiQueryKeys = {
  all: () => [DISCOUNTS_BASE_QUERY_KEY] as const,
  byTourId: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, DISCOUNTS_BASE_QUERY_KEY] as const,
  byId: (discountId: string) => [DISCOUNTS_BASE_QUERY_KEY, discountId] as const,
};
